import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { FilterToggleEvent, FilterItem } from '../../models/filter'

@Component({
  selector: 'app-filter-group',
  templateUrl: './filter-group.component.html',
  styleUrls: ['./filter-group.component.scss']
})
export class FilterGroupComponent implements OnInit {
  @Input() groupName: string
  @Input() filterItems: FilterItem[] = []

  @Output() filterToggled = new EventEmitter<FilterToggleEvent>()

  constructor() { }

  ngOnInit() {
  }

  onFilterToggled(event: FilterToggleEvent) {
    this.filterToggled.emit(event)
  }
}
